export default "__VITE_ASSET__CoQG8YTO__"